<template>
  <v-slide-x-reverse-transition mode="out-in">
    <v-card-text class="document-content pa-0 pl-46-px border">
      <CreateBtens v-if="createBtnShow" :item="options.data"></CreateBtens>
      <draggable
        :list="options.data.list"
        :disabled="!swapBtnShow"
        handle=".handle"
        @start="dragStart"
        @end="dragEnd"
        @change="onUpdate(options.data.list, $event)"
      >
        <template v-for="(content, content_i) in options.data.list">
          <transition-group
            type="transition"
            :key="content.format + '--' + content_i"
          >
            <div
              v-if="content.content !== '' || editMode"
              class="relative d-flex align-stretch"
              :key="content.format + '-' + content_i"
            >
              <div
                v-if="modifyMode.show && options.editedAuth"
                class="w-40-px ctxIdTag grey--text text--lighten-1"
              >
                #{{ content.ctxId }}
                <div class="text-right pr-4-px">{{ content.sn }}</div>
              </div>

              <component
                :is="content.format"
                :data="content"
                :hoverColor="contentHoverColor"
                :modifyMode="modifyMode"
                :editedAuth="options.editedAuth"
                class="content-area flex-grow-1"
                :class="{
                  'h-60-px overflow-hidden pr-10-px':
                    options.limitContentHeight,
                  'pr-10-px w-64-calc-pct': swapBtnShow
                }"
              ></component>

              <v-btn
                v-if="swapBtnShow"
                class="handle h-auto my-8-px flex-grow-0"
                dark
              >
                <v-icon class="fz-16-px">mdi-sort</v-icon>
              </v-btn>
            </div>

            <CreateBtens
              v-if="createBtnShow"
              :key="'createBtn-m-' + content_i"
              :item="options.data"
              :content="content"
            ></CreateBtens>
          </transition-group>
        </template>
      </draggable>
    </v-card-text>
  </v-slide-x-reverse-transition>
</template>

<script>
import draggable from 'vuedraggable'

import DialogChapter from '@/components/elements/block/DialogChapter.vue'
import CreateBtens from '@/components/elements/contentType/CreateContentBtns.vue'

import Html from '@/components/elements/contentType/Html.vue'
import Panel from '@/components/elements/contentType/Panel.vue'
import Table from '@/components/elements/contentType/Table.vue'

import { mapState } from 'vuex'

export default {
  name: 'ContentListArea',

  inject: ['mapResult'],

  props: ['options'],

  components: {
    draggable,
    DialogChapter,
    CreateBtens,
    Panel,
    Html,
    Table
  },

  data() {
    return {
      contentHoverColor: '#033c63',
      dragging: false
    }
  },

  computed: {
    ...mapState('common', ['modifyMode', 'lang']),
    editMode() {
      return this.modifyMode.show && this.options.editedAuth
    },
    createBtnShow() {
      return (
        this.editMode &&
        this.lang !== 'en' &&
        !this.dragging &&
        !this.options.limitContentHeight
      )
    },
    swapBtnShow() {
      return this.editMode && this.lang !== 'en'
    }
  },

  methods: {
    dragStart() {
      this.dragging = true
    },
    dragEnd() {
      this.dragging = false
    },
    onUpdate(list, move) {
      console.log(list, move)
      if (!move) {
        this.setSnackbar({ show: true, text: 'ERROR' })
        return
      }
      const moved = move.moved
      const prevSn = moved.newIndex !== 0 ? list[moved.newIndex - 1].sn : 0
      const data = {
        ctxId: moved.element.ctxId,
        sn: prevSn + 1
      }
      this.$api.common.leaf.swap(data).then(() => {
        this.mapResult()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ctxIdTag {
  position: absolute;
  right: calc(100% + 10px);
}
</style>
